<div>
  <h2>MIPS Comments</h2>
  @for (comment of mipsComments; track comment) {
    <div>
      <h3>{{ comment.displayTitle }}</h3>
      <p>{{ comment.commentText }}</p>
    </div>
  }
</div>
